import { render, staticRenderFns } from "./mark.vue?vue&type=template&id=164e98b0&"
import script from "./mark.vue?vue&type=script&lang=js&"
export * from "./mark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('164e98b0')) {
      api.createRecord('164e98b0', component.options)
    } else {
      api.reload('164e98b0', component.options)
    }
    module.hot.accept("./mark.vue?vue&type=template&id=164e98b0&", function () {
      api.rerender('164e98b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/mbl/mark.vue"
export default component.exports